import type { EditorialNavVariant } from 'components/HomepageV3/components/EditorialNav';

/**
 * Derives the EditorialNav auth props (logged-in/out variant + account display
 * name) from live auth state, so every SE3 surface (homepage, explore, private)
 * reflects the signed-in user instead of a static `loggedOut` default
 * (PD-36055 #1). `isSignedIn` is tri-state: `true`/`false` from the auth hook,
 * `null`/`undefined` while it resolves → `authPending` (neutral nav).
 */
export interface EditorialNavAuth {
  variant: EditorialNavVariant;
  accountName: string;
}

export function deriveEditorialNavAuth(isSignedIn: boolean | null | undefined): EditorialNavAuth {
  let variant: EditorialNavVariant = 'authPending';
  if (isSignedIn === true) variant = 'loggedIn';
  else if (isSignedIn === false) variant = 'loggedOut';

  // Hannah QA: the signed-in nav shows a generic "My Account", not the member's name.
  return { variant, accountName: 'My Account' };
}
